<template>
    <div class="org-select-tree-list">
        <v-spinner
            v-if="loading"
            status="default"
            class="org-select-loading"
        />
        <v-tree
            v-else
            ref="tree"
            :maps="maps"
            :options="currentOptions"
            :selected="currentSelected"
            :single="single"
            :folder-can-select="folderCanSelect"
            :only-folder-id="onlyFolderId"
            :user-indent="25"
            :with-checkbox="!single"
            @sync="syncTree"
            @change="selectedChange"
        >
            <template
                slot="label"
                slot-scope="props"
            >
                <org-item
                    :option="props.options"
                    :tips="getOrgTips(props.options)"
                >
                    <span
                      slot="text"
                      v-html="props.options.name"
                    />
                </org-item>
            </template>
        </v-tree>
    </div>
</template>

<script>
import OrgItem from '@/components/org-item';
import { formatListData } from './utils/format';

export default {
  components: {
    OrgItem,
  },
  props: {
    hisSelected: {
      type: Array,
      default() {
        return [];
      },
    },

    selected: {
      type: Array,
      default() {
        return [];
      },
    },

    single: {
      type: Boolean,
      default: false,
    },

    folderCanSelect: {
      type: Boolean,
      default: true,
    },

    onlyFolderId: {
      type: Boolean,
      default: true,
    },

    custFetchTree: {
      type: Function,
      default: null,
    },

    maps: {
      type: Object,
      default: () => ({
        value: 'id',
        hasChildren: 'isFolder',
      }),
    },
  },
  data() {
    return {
      loading: false,

      currentOptions: [],
      currentSelected: [],
    };
  },
  watch: {
    currentInit(val) {
      if (val) {
        this.loading = false;
        this.fetchInitData();
      }
    },

    selected(nextValue) {
      this.setCurrentSelectedVal(nextValue);
    },
  },

  created() {
    this.setCurrentSelectedVal(this.selected);
  },

  mounted() {
    this.fetchInitData();
  },
  methods: {
    fetchInitData() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      this.getTreeData(0, true)
        .then((res) => {
          this.fetchInitDataError = false;
          this.loading = false;
          const { allTreeData, list } = res || {};
          if (allTreeData) {
            this.currentOptions = allTreeData;
          } else {
            this.currentOptions = formatListData(list, this.hisSelected) || [];
          }

          if (this.currentOptions.length === 1) {
            this.$nextTick(() => {
              this.$refs.tree.expand(0);
            });
          }
        })
        .catch(() => {
          this.fetchInitDataError = true;
          this.loading = false;
        });
    },

    selectedChange(selected) {
      this.$emit('change', selected);
    },

    syncTree($vm) {
      const orgId = $vm.options.id;
      this.getTreeData(orgId)
        .then((res) => {
          const records = formatListData(res.list, this.hisSelected) || [{}];
          $vm.addChild(records);
          $vm.hideLoading();
          $vm.setSynced();
        })
        .catch(() => {
          $vm.hideLoading();
          $vm.expand = false;
        });
    },
    getTreeData(orgId, isFirstFetch) {
      const reqData = { id: orgId };
      let defer;

      if (this.custFetchTree) {
        defer = this.custFetchTree({ isFirstFetch, ...reqData });
      } else {
        defer = this.$ajax.get('/mng/org/getOrgAndUserTreeNodes', {
          params: reqData,
        });
      }

      defer.catch((res) => {
        this.$message.error(res.message || this.$t('获取数据失败'));
      });

      return defer;
    },

    setCurrentSelectedVal(arr) {
      this.currentSelected = arr;
    },

    getTree() {
      return this.$refs.tree;
    },

    getOrgTips(item) {
      return item.tips;
    },
  },
};
</script>
